export default __webpack_public_path__ + "media/images/gradient1_dev-187713ac3f30681f411e4667d4e001f2.png";